/* Desktop zoom */

const zoomCursor = document.getElementById('zoom-cursor');

document.addEventListener('mousemove', e => {
    zoomCursor.style.left = e.clientX + 'px';
    zoomCursor.style.top = e.clientY + 'px';
});


document.querySelectorAll('.product-gallery__media[data-media-type="image"]').forEach(wrapper => {
    const img = wrapper.querySelector('img');
    if (!img) return;

    let zoomed = false;

    wrapper.addEventListener('mouseenter', () => {
        if (window.innerWidth < 1000) return;

        zoomCursor.style.opacity = '1';
        zoomCursor.classList.add('is-plus');
        zoomCursor.classList.remove('is-minus');
    });
    wrapper.addEventListener('mouseleave', () => {
        zoomed = false;
        img.style.transform = '';
        wrapper.classList.remove('is-zoomed');

        zoomCursor.style.opacity = '0';
        zoomCursor.classList.remove('is-plus', 'is-minus');
    });
    wrapper.addEventListener('click', () => {
        if (window.innerWidth <= 768) return;

        zoomed = !zoomed;

        if (zoomed) {
            img.style.transformOrigin = '50% 50%';
            img.style.transform = `scale(${getComputedStyle(wrapper).getPropertyValue('--zoom-scale')})`;

            zoomCursor.classList.remove('is-plus');
            zoomCursor.classList.add('is-minus');
        } else {
            img.style.transform = '';
            zoomCursor.classList.remove('is-minus');
            zoomCursor.classList.add('is-plus');
        }
    });

    wrapper.addEventListener('mousemove', e => {
        if (!zoomed) return;

        const rect = wrapper.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
    });
});

/* Deskto zoom end */

/* Mobile zoom */
const zoomOverlay = document.getElementById('mobile-image-zoom');
const zoomStage = zoomOverlay.querySelector('.mobile-zoom-stage');
const closeBtn = zoomOverlay.querySelector('.mobile-zoom-close');


document.querySelectorAll('.product-gallery__media img').forEach(img => {
    img.addEventListener('click', () => {
        if (window.innerWidth > 999) return;

        const clone = img.cloneNode(true);
        const scale = 2.5;

        clone.style.width = `${img.naturalWidth * scale}px`;
        clone.style.height = `${img.naturalHeight * scale}px`;
        clone.style.maxWidth = 'none';
        clone.style.maxHeight = 'none';

        zoomStage.innerHTML = '';
        zoomStage.appendChild(clone);

        zoomOverlay.hidden = false;
        document.body.style.overflow = 'hidden';

        requestAnimationFrame(() => {
            zoomStage.scrollLeft =
                (zoomStage.scrollWidth - zoomStage.clientWidth) / 2;
            zoomStage.scrollTop =
                (zoomStage.scrollHeight - zoomStage.clientHeight) / 2;
        });
    });
});

closeBtn.addEventListener('click', () => {
    zoomOverlay.hidden = true;
    zoomStage.innerHTML = '';
    document.body.style.overflow = '';
});
/* Mobile zoom end*/

document.addEventListener('click', (e) => {
    const btn = e.target.closest('.discount-promotion__copy-icon');
    if (!btn || !btn.dataset.code) return;
    navigator.clipboard.writeText(btn.dataset.code);
    btn.classList.add('is-copied');
    clearTimeout(btn._copyTimeout);
    btn._copyTimeout = setTimeout(() => {
        btn.classList.remove('is-copied');
    }, 2000);
});

function getDiscountCookie(name) {
    const match = document.cookie
        .split('; ')
        .find((row) => row.trim().startsWith(name + '='));
    if (!match) return '';

    const value = match.split('=').slice(1).join('=').trim();
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}

function parseExcludedCodes(value) {
    return String(value || '')
        .split(',')
        .map((code) => code.trim().toLowerCase())
        .filter(Boolean);
}

function getCookiePreferredDiscountCode() {
    return (
        getDiscountCookie('discount_code_viewed') ||
        getDiscountCookie('discount_code_valid') ||
        getDiscountCookie('discount_code') ||
        ''
    );
}

function getCartDiscountCode(cart) {
    const applicableDiscountCode = cart?.discount_codes?.find(
        (discount) => discount?.applicable && discount?.code
    );
    if (applicableDiscountCode?.code) {
        return applicableDiscountCode.code;
    }

    const discountApp = cart?.cart_level_discount_applications?.find(
        (app) => app.type === 'discount_code' && app.title
    );

    return discountApp?.title || '';
}

function resolveDisplayedDiscountCode(box, cart) {
    const defaultCode = box.dataset.defaultCode || '';
    const excludedCodes = parseExcludedCodes(box.dataset.excludedCodes);

    if (cart) {
        const cartCode = getCartDiscountCode(cart);
        if (cartCode && !excludedCodes.includes(cartCode.toLowerCase())) {
            return cartCode.toUpperCase();
        }

        // Cart has items but no active code — trust server state, not stale cookies.
        if (cart.item_count > 0) {
            return defaultCode.toUpperCase();
        }
    }

    const cookieCode = getCookiePreferredDiscountCode();
    if (cookieCode && !excludedCodes.includes(cookieCode.toLowerCase())) {
        return cookieCode.toUpperCase();
    }

    return defaultCode.toUpperCase();
}

function updateDiscountPromotionBox(box, cart) {
    const codeNode = box.querySelector('[data-discount-promotion-code]');
    const copyButton = box.querySelector('[data-discount-promotion-copy]');
    if (!codeNode || !copyButton) return;

    const code = resolveDisplayedDiscountCode(box, cart);
    codeNode.textContent = code;
    copyButton.dataset.code = code;
}

async function fetchCartForDiscountPromotion() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
        throw new Error('Failed to fetch cart');
    }

    return response.json();
}

function initDiscountPromotionSync() {
    const boxes = Array.from(document.querySelectorAll('[data-discount-promotion]'));
    if (!boxes.length) return;

    let refreshTimer = null;

    const render = (cart) => {
        boxes.forEach((box) => updateDiscountPromotionBox(box, cart));
    };

    const refreshFromServer = () => {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(async () => {
            try {
                const cart = await fetchCartForDiscountPromotion();
                render(cart);
            } catch {
                render(null);
            }
        }, 120);
    };

    render(null);
    refreshFromServer();

    document.addEventListener('cart:change', (event) => {
        render(event.detail?.cart || null);
    });

    document.addEventListener('cart:refresh', () => {
        refreshFromServer();
    });

    document.addEventListener('discount:visual-updated', (event) => {
        render(event.detail?.cart || null);
        if (!event.detail?.cart) {
            refreshFromServer();
        }
    });

    window.addEventListener('pageshow', () => {
        refreshFromServer();
    });
}

document.addEventListener('DOMContentLoaded', initDiscountPromotionSync);

/* Product gallery: block native image drag so scroll-carousel allow-drag works on images */
document.querySelectorAll('scroll-carousel.product-gallery__carousel').forEach((carousel) => {
    carousel.addEventListener(
        'dragstart',
        (event) => {
            if (event.target.closest('img')) {
                event.preventDefault();
            }
        },
        { capture: true }
    );
});

/* Desktop scroll controls */
const galleryWrapper = document.querySelector('.product-gallery__scroll-carousel--active');

if (galleryWrapper) {
    const gallery = galleryWrapper.querySelector('.product-gallery__scroll-carousel');
    const prevBtn = galleryWrapper.querySelector('.scroll-btn.prev');
    const nextBtn = galleryWrapper.querySelector('.scroll-btn.next');
    const thumb = galleryWrapper.querySelector('.scrollbar-thumb');

    if (gallery && prevBtn && nextBtn && thumb) {
        const scrollAmount = 200;

        function updateThumb() {
            const scrollTop = gallery.scrollTop;
            const scrollHeight = gallery.scrollHeight - gallery.clientHeight;

            const thumbHeightPercent = (gallery.clientHeight / gallery.scrollHeight) * 100;
            thumb.style.height = `${thumbHeightPercent}%`;

            const scrollPercent = scrollHeight > 0 ? scrollTop / scrollHeight : 0;
            thumb.style.top = `${scrollPercent * (100 - thumbHeightPercent)}%`;

            prevBtn.disabled = scrollTop <= 0;
            nextBtn.disabled = scrollTop >= scrollHeight;
        }

        prevBtn.addEventListener('click', () => {
            gallery.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', () => {
            gallery.scrollBy({ top: scrollAmount, behavior: 'smooth' });
        });

        gallery.addEventListener('scroll', updateThumb);

        updateThumb();
    }
}

/* Desktop scroll controls end */


function closeComplementaryPopup() {
    document.querySelector('.complementary-products-popup')?.classList.remove('open');
    document.querySelector('.complementary-products-popup__overlay')?.classList.remove('open');
    document.documentElement.classList.remove('lock');
}
function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && !cartDrawer.open) {
        setTimeout(() => {
            cartDrawer.show();
        }, 600);
    }
}
document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('.complementary-products-custom__btn');
    const closeBtn = e.target.closest('.complementary-products-popup__close');
    const overlayClick = e.target.classList.contains('complementary-products-popup__overlay');

    const popup = document.querySelector('.complementary-products-popup');
    const overlay = document.querySelector('.complementary-products-popup__overlay');
    const html = document.documentElement;

    if (!popup || !overlay) return;


    if (openBtn) {
        popup.classList.add('open');
        overlay.classList.add('open');
        html.classList.add('lock');


        if (popup.parentNode !== document.body) {
            document.body.appendChild(popup);
        }
        if (overlay.parentNode !== document.body) {
            document.body.appendChild(overlay);
        }
        return;
    }


    if (closeBtn || overlayClick) {
        closeComplementaryPopup();
    }
});


document.addEventListener('click', async function (e) {
    const addBtn = e.target.closest('.complementary-products-popup__btn');
    if (!addBtn || addBtn.classList.contains('is-disabled')) return;
    if (addBtn.getAttribute('aria-busy') === 'true') return;

    const popupBody = addBtn.closest('.complementary-products-popup__body');
    if (!popupBody) return;

    const pickers = popupBody.querySelectorAll('variant-picker-custom');
    if (!pickers.length) return;

    const parentVariantId = parseInt(pickers[0].dataset.selectedVariantId);
    if (!parentVariantId) return;

    addBtn.setAttribute('aria-busy', 'true');
    addBtn.disabled = true;

    const items = [];

    const mainVariantId = parseInt(pickers[0].dataset.selectedVariantId);
    if (mainVariantId) {
        items.push({
            id: mainVariantId,
            quantity: 1
        });
    }

    pickers.forEach((picker, index) => {
        if (index === 0) return;

        const variantId = parseInt(picker.dataset.selectedVariantId);
        if (!variantId) return;

        items.push({
            id: variantId,
            quantity: 1,
            parent_id: parentVariantId
        });
    });


    try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({ items })
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('Error response:', errorText);


            try {
                const errorJson = JSON.parse(errorText);
                console.error('Parsed error:', errorJson);
            } catch (e) {

            }

            throw new Error(`HTTP ${response.status}: ${errorText}`);
        }

        const result = await response.json();

        closeComplementaryPopup();
        openCartDrawer();

    } catch (err) {
        console.error('Failed to add complementary products', err);

        if (err.message && err.message.includes('422')) {

            try {
                const itemsWithoutParent = items.map(item => {
                    const { parent_id, ...rest } = item;
                    return rest;
                });

                const fallbackResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                    body: JSON.stringify({ items: itemsWithoutParent })
                });

                if (fallbackResponse.ok) {
                    await fallbackResponse.json();
                    closeComplementaryPopup();
                    openCartDrawer();
                    return;
                }
            } catch (fallbackErr) {
                console.error('Fallback also failed:', fallbackErr);
            }
        }
    } finally {
        addBtn.removeAttribute('aria-busy');
        addBtn.disabled = false;
    }
});

document.addEventListener('click', function (e) {
    const link = e.target.closest('.product-rating__url');
    if (!link) return;

    const targetId = link.getAttribute('href');
    if (!targetId || !targetId.startsWith('#')) return;

    const targetEl = document.querySelector(targetId);
    if (!targetEl) return;

    e.preventDefault();

    const offset = 100;
    const targetPosition =
        targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
});

function closeComplementaryAlterPopup() {
    document.querySelectorAll('.complementary-products-alter-popup').forEach(el => el.classList.remove('open'));
    document.querySelectorAll('.complementary-products-alter-popup__overlay').forEach(el => el.classList.remove('open'));
    document.documentElement.classList.remove('lock');
}

document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('.complementary-products-alter__btn');
    const closeBtn = e.target.closest('.complementary-products-popup__close');
    const overlayClick = e.target.classList.contains('complementary-products-alter-popup__overlay');

    if (openBtn) {
        const id = openBtn.dataset.id;
        const popup = document.querySelector(`.complementary-products-alter-popup[data-id="${id}"]`);
        const overlay = document.querySelector(`.complementary-products-alter-popup__overlay[data-id="${id}"]`);
        if (!popup || !overlay) return;

        popup.classList.add('open');
        overlay.classList.add('open');
        document.documentElement.classList.add('lock');

        if (popup.parentNode !== document.body) document.body.appendChild(popup);
        if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
        return;
    }

    if (closeBtn || overlayClick) {
        closeComplementaryAlterPopup();
    }


    const addBtn = e.target.closest('.complementary-products-alter-popup__btn');
    if (addBtn && !addBtn.classList.contains('is-disabled')) {
        if (addBtn.getAttribute('aria-busy') === 'true') return;

        const popupBody = addBtn.closest('.complementary-products-popup__body');
        if (!popupBody) return;

        const pickers = popupBody.querySelectorAll('variant-picker-custom');
        if (!pickers.length) return;

        const compVariantId = parseInt(pickers[0].dataset.selectedVariantId);
        if (!compVariantId) return;

        addBtn.setAttribute('aria-busy', 'true');
        addBtn.disabled = true;

        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: compVariantId,
                    quantity: 1
                }]
            })
        })
            .then(response => response.json())
            .then(data => {
                closeComplementaryAlterPopup();
                openCartDrawer();
                const popup = addBtn.closest('.complementary-products-alter-popup');
                const productId = popup && popup.dataset.id;
                if (productId) {
                    const cardBtn = document.querySelector(`.complementary-products-alter__btn[data-id="${productId}"]`);
                    if (cardBtn && cardBtn.dataset.btnTextAfter) {
                        cardBtn.classList.add('added');
                        cardBtn.textContent = cardBtn.dataset.btnTextAfter;
                    }
                }
            })
            .catch(error => {
                console.error('Error adding complementary product:', error);
            })
            .finally(() => {
                addBtn.removeAttribute('aria-busy');
                addBtn.disabled = false;
            });
    }
});

function updateComplementaryAlterButtonsFromCart(cartOrNull) {
    const buttons = document.querySelectorAll('.complementary-products-alter__btn[data-id][data-btn-text][data-btn-text-after]');
    if (!buttons.length) return;

    function applyCart(cart) {
        const productIdsInCart = new Set((cart.items || []).map(item => String(item.product_id)));
        buttons.forEach(btn => {
            const productId = btn.dataset.id;
            const inCart = productIdsInCart.has(String(productId));
            if (inCart) {
                btn.classList.add('added');
                btn.textContent = btn.dataset.btnTextAfter || '';
            } else {
                btn.classList.remove('added');
                btn.textContent = btn.dataset.btnText || '';
            }
        });
    }

    if (cartOrNull && (cartOrNull.items || cartOrNull.item_count !== undefined)) {
        applyCart(cartOrNull);
        return;
    }

    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
        .then(response => response.json())
        .then(applyCart)
        .catch(() => {});
}

document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart) updateComplementaryAlterButtonsFromCart(e.detail.cart);
});
document.addEventListener('cart:refresh', function () {
    setTimeout(() => updateComplementaryAlterButtonsFromCart(), 100);
});
document.addEventListener('cart-drawer:refreshed', () => updateComplementaryAlterButtonsFromCart());

function initComplementaryProductsAlterSwiper() {
    const swiperEl = document.querySelector('.complementary-products-alter__swiper');
    if (!swiperEl || swiperEl.swiper) return;

    const initSwiper = () => {
        if (!swiperEl || swiperEl.swiper || typeof window.Swiper === 'undefined') return;

        new window.Swiper(swiperEl, {
            slidesPerView: 3,
            spaceBetween: 12,
            loop: true,
            navigation: {
                nextEl: document.querySelector('.complementary-products-alter__next'),
                prevEl: document.querySelector('.complementary-products-alter__prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 2.3
                },
                768: {
                    slidesPerView: 3
                },
            },
        });
    };

    if (typeof window.Swiper === 'undefined') {
        if (window.RO && typeof window.RO.loadSwiper === 'function') {
            window.RO.loadSwiper().catch(() => {});
        }

        const onSwiperReady = () => {
            window.removeEventListener('swiper:ready', onSwiperReady);
            initSwiper();
        };

        window.addEventListener('swiper:ready', onSwiperReady, { once: true });
        return;
    }

    initSwiper();
}

document.addEventListener('DOMContentLoaded', initComplementaryProductsAlterSwiper);
document.addEventListener('complementary-products-alter:loaded', initComplementaryProductsAlterSwiper);

function submitBIS(wrapper) {
    const emailInput = wrapper.querySelector('.klaviyo-bis__email');
    const successMsg = wrapper.querySelector('.success-message');
    const errorMsg = wrapper.querySelector('.error-message');
    const submitBtn = wrapper.querySelector('.klaviyo-bis__button');

    const email = emailInput?.value.trim();
    const variantId = wrapper.dataset.vid;
    const publicApiKey = 'TmAwti';

    successMsg?.classList.add('hidden');
    errorMsg?.classList.add('hidden');

    if (!email || !variantId) {
        errorMsg?.classList.remove('hidden');
        setTimeout(() => errorMsg?.classList.add('hidden'), 10000);
        return;
    }

    submitBtn?.setAttribute('disabled', 'disabled');

    const payload = {
        data: {
            type: "back-in-stock-subscription",
            attributes: {
                profile: { data: { type: "profile", attributes: { email } } },
                channels: ["EMAIL"]
            },
            relationships: { variant: { data: { type: "catalog-variant", id: `$shopify:::$default:::${variantId}` } } }
        }
    };

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${publicApiKey}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-06-15' },
        body: JSON.stringify(payload)
    })
        .then(res => {
            if (res.status === 202) {
                emailInput.value = '';
                successMsg?.classList.remove('hidden');
                setTimeout(() => successMsg?.classList.add('hidden'), 10000);
            } else {
                return res.json().then(err => {
                    console.error('BIS error:', err);
                    errorMsg?.classList.remove('hidden');
                    setTimeout(() => errorMsg?.classList.add('hidden'), 10000);
                });
            }
        })
        .catch(err => {
            console.error('BIS fetch error:', err);
            errorMsg?.classList.remove('hidden');
            setTimeout(() => errorMsg?.classList.add('hidden'), 10000);
        })
        .finally(() => submitBtn?.removeAttribute('disabled'));
}


document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.klaviyo-bis__button') || e.target.closest('.klaviyo-bis__button .button__content');
    if (!trigger) return;

    e.preventDefault();
    const wrapper = trigger.closest('.klaviyo-bis');
    if (!wrapper) return;

    submitBIS(wrapper);
});


document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;

    const input = e.target.closest('.klaviyo-bis__email');
    if (!input) return;

    e.preventDefault();
    const wrapper = input.closest('.klaviyo-bis');
    if (!wrapper) return;

    submitBIS(wrapper);
});

document.addEventListener('variant:change', function (e) {
    const buyButtonsBlock = document.querySelector('.shopify-section--main-product [data-block-type="buy-buttons"]');
    const bisWrapper = buyButtonsBlock?.querySelector('.klaviyo-bis');
    if (!bisWrapper) return;

    const productForm = buyButtonsBlock.querySelector('product-form');
    if (productForm?.dataset?.comingSoon === 'true') {
        bisWrapper.classList.remove('show');
        return;
    }

    const variant = e.detail.variant;
    bisWrapper.dataset.vid = variant.id;

    if (!variant.available) {
        bisWrapper.classList.add('show');
    } else {
        bisWrapper.classList.remove('show');
    }

});

document.addEventListener('variant:change', function (e) {
    const variant = e.detail && e.detail.variant ? e.detail.variant : null;
    if (!variant) return;

    const skuRows = document.querySelectorAll('[data-accordion-sku-row]');
    if (!skuRows.length) return;

    skuRows.forEach((row) => {
        const skuValue = row.querySelector('[data-accordion-sku-value]');
        if (!skuValue) return;

        const nextSku = variant.sku ? String(variant.sku).trim() : '';
        skuValue.textContent = nextSku;
        row.hidden = !nextSku;
    });
});


/* Cart lock newsletter */
document.addEventListener("DOMContentLoaded", function () {
    const form = document.querySelector(".cart-lock .newsletter-form__form");
    if (!form) return;
  
    const wrapper = form.closest(".newsletter-form");
    const listId = wrapper?.dataset.listId;
  
    const fnameInput = form.querySelector(".newsletter-form__fname");
    const lnameInput = form.querySelector(".newsletter-form__lname");
    const emailInput = form.querySelector(".newsletter-form__email");
  
    const successMsg = form.querySelector(".newsletter-form__success");
    const errorMsg = form.querySelector(".newsletter-form__error");
    const whatsappBtn = form.querySelector(".newsletter-form__whatsapp");
  

    if (whatsappBtn) {
      whatsappBtn.addEventListener("click", () => {
        const phone = "4917647056710";
        const encodedMessage = encodeURIComponent(
          whatsappBtn.dataset.message || ""
        );
  
        const url =
          "https://api.whatsapp.com/send/?phone=" +
          phone +
          "&text=" +
          encodedMessage;
  
        window.open(url, "_blank");
      });
    }
  
    form.addEventListener("submit", function (e) {
      e.preventDefault();
  
      const firstName = fnameInput?.value.trim();
      const lastName = lnameInput?.value.trim();
      const email = emailInput?.value.trim();
  
      if (!email || !listId) {
        errorMsg.classList.remove("hidden");
        setTimeout(() => errorMsg.classList.add("hidden"), 2000);
        return;
      }
  
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=TmAwti", {
        method: "POST",
        headers: {
          revision: "2023-08-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Shopify",
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    first_name: firstName,
                    last_name: lastName,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId,
                },
              },
            },
          },
        }),
      })
        .then((res) => {
          if (!res.ok) throw new Error("Klaviyo error");
  
          successMsg.classList.remove("hidden");
          setTimeout(() => successMsg.classList.add("hidden"), 2000);
          form.reset();
        })
        .catch(() => {
          errorMsg.classList.remove("hidden");
          setTimeout(() => errorMsg.classList.add("hidden"), 2000);
        });
    });
  });
